////////////////////////////////////////////
//
// Flickity Carousel Functions
//
////////////////////////////////////////////

var $ = require('jquery');
var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');
var Flickity = require('flickity-bg-lazyload');
var Flickity = require('flickity-imagesloaded');

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

// Hack for IE to prevent scroll jumping bug
// https://github.com/metafizzy/flickity/issues/651#issuecomment-384974621

var focus = Flickity.prototype.focus;
Flickity.prototype.focus = function() {
  // use non-standard setActive for IE11. #651
  if ( this.element.setActive  ) {
    this.element.setActive();
    return;
  }
  // use default
  focus.apply( this, arguments );
};

// custom SVG arrow
// arrowShape: 'M63.9.9L35.3 50.7l29.6 48.4'

// Image Carousel
$('.js-image-carousel').flickity({
  cellSelector: '.image-carousel__slide',
  wrapAround: true,
  cellAlign: 'left',
  prevNextButtons: false,
  setGallerySize: false,
  lazyLoad: 2,
  imagesLoaded: true
});

// Case Study Carousel
$('.js-case-study-carousel').flickity({
  cellSelector: '.case-study-carousel__slide',
  wrapAround: true,
  cellAlign: 'center',
  prevNextButtons: false,
  setGallerySize: false,
  lazyLoad: true,
  bgLazyLoad: true
});

// Card Carousel
$('.js-card-carousel').flickity({
  cellSelector: '.card-carousel__slide',
  cellAlign: 'center',
  prevNextButtons: false,
  percentPosition: false,
  contain: true,
  imagesLoaded: true
});

// Featured card carousel
//
// This code is a duplicated in `js/vue/work-filter.js` to reinit Flickity
// after AJAX load. If you change something here, make the change there as well.
// Sorry for the inconvenience. :/
// Maybe one day we'll refactor this to be an importable function or something.
$('.js-featured-card-carousel').flickity({
  cellSelector: '.featured-card__slide',
  wrapAround: true,
  prevNextButtons: false,
  setGallerySize: false
});

// Quote carousel
$('.js-quote-carousel').flickity({
  cellSelector: '.quote-carousel__slide',
  wrapAround: true,
  cellAlign: 'center',
  arrowShape: 'M63.9.9L35.3 50.7l29.6 48.4',
  adaptiveHeight: true
});
